import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';

interface InfoActionMessageProps {
    title: string;
    description: string;
    buttonText: string;
    onButtonClick: () => void;
}

export const InfoActionMessage = ({ title, description, buttonText, onButtonClick }: InfoActionMessageProps) => {
    return (
        <Box sx={{ 
            p: 8,
            margin: 'auto',
            maxWidth: 400,
            gap: 1, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            textAlign: 'center', 

            justifyContent: 'center' 
        }}>
            <Typography variant="body1" color={APP_CONFIG.ui.theme.colors.primaryText}>
                {title}
            </Typography>
            <Typography variant="body2" color={APP_CONFIG.ui.theme.colors.secondaryText}>
                {description}
            </Typography>
            <Button 
                variant="outlined" 
                color="primary" 
                onClick={onButtonClick}
            >
                {buttonText}
            </Button>
        </Box>
    );
}; 